import { ITableColumn } from "src/app/common/components/table/interfaces/table-column";

export const usersTableConfig: { columns: Array<ITableColumn>; nestedColumns: Array<ITableColumn> } = {
  columns: [
    {
      id: "name",
      type: "text",
      key: "USER_SETTINGS.NAME",
      style: {
        width: "19%"
      }
    },
    {
      id: "email",
      type: "text",
      key: "USER_SETTINGS.EMAIL",
      style: {
        width: "19%"
      }
    },
    {
      id: "municipalitiesCount",
      type: "text",
      key: "USER_SETTINGS.MUNICIPALITIES_COUNT",
      style: {
        width: "19%"
      }
    },
    {
      id: "activeEmailCount",
      type: "text",
      key: "USER_SETTINGS.EMAIL_COUNT",
      style: {
        width: "19%"
      }
    },
    {
      id: "expand",
      type: "action",
      actionIcon: "ec_networks_mix_addrow",
      selectedIcon: "ec_networks_mix_deleterow",
      key: "",
      style: {
        "text-align": "center"
      }
    }
  ],
  nestedColumns: [
    {
      id: "region",
      type: "text",
      key: "USER_SETTINGS.MUNICIPALITY",
      style: {
        width: "26%"
      }
    },
    {
      id: "role",
      type: "text",
      key: "USER_SETTINGS.REGION_ROLE",
      style: {
        width: "25%"
      }
    },
    {
      id: "emailConfig",
      type: "notification-settings",
      key: "USER_SETTINGS.EMAIL_SETTINGS"
    }
  ]
};
